module.exports = __webpack_public_path__ + "img/ico_view_arrow_right.d3015959.svg";